import { render, staticRenderFns } from "./RaceIndex.vue?vue&type=template&id=0a4732c0&scoped=true"
import script from "./RaceIndex.vue?vue&type=script&lang=js"
export * from "./RaceIndex.vue?vue&type=script&lang=js"
import style0 from "./RaceIndex.vue?vue&type=style&index=0&id=0a4732c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4732c0",
  null
  
)

export default component.exports